import { BaseClient } from '../client';
import { TGrupoConcessionaria } from './groupDealer.types';
import { NavigateFunction } from "react-router-dom";


interface setGroupDealerProps {
  id: string;
  grupoConcessionaria: string;
  tagAtivo: boolean;
  logotipo: File | null;
  idUserIndicador?: number;
  setToast: (toast: { message: string, variant: 'success' | 'error' }) => void;
  navigate: NavigateFunction;

}

export const putGroupDealer = async (dealerPutProps: setGroupDealerProps) => {
  // if (process.env.NODE_ENV === 'development') {
  //   return 'Alterado com sucesso';
  // }
  

  try {
    const formData = new FormData();
    formData.append('Id', dealerPutProps.id);
    formData.append('Descricao', dealerPutProps.grupoConcessionaria);
    formData.append('Ativo', dealerPutProps.tagAtivo.toString());
    if (dealerPutProps.idUserIndicador) {
      formData.append('IdUserIndicador', String(dealerPutProps.idUserIndicador));
    }
    if (dealerPutProps.logotipo) {
      formData.append('Logotipo', dealerPutProps.logotipo);
    }

    const response = await BaseClient.post<TGrupoConcessionaria>(`v2/Concessionaria/AtualizarGrupoConcessionaria`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    if (response.status === 200) {
      dealerPutProps.navigate(`/cadastros/grupo-concessionarias`);
      dealerPutProps.setToast({
          message: 'Concessionária atualizada com sucesso!',
          variant: 'success',
      });
      return response.data; 
  } else {
      dealerPutProps.navigate(`/cadastros/grupo-concessionarias/editar/${dealerPutProps.id}`);
      dealerPutProps.setToast({
          message: 'Erro ao atualizada a concessionária. Tente novamente.',
          variant: 'error',
      });
  }

  return response.data;

  } catch (error) {
    console.error(error);
    dealerPutProps.navigate(`/cadastros/grupo-concessionarias/editar/${dealerPutProps.id}`);
    dealerPutProps.setToast({
      message: 'Erro ao atualizada a concessionária. Tente novamente.',
      variant: 'error',
  });
  }
};
